<script setup>

</script>

<template>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.0624 39H32.9374C34.077 39 35 38.0847 35 36.9546V17L27 9H15.0624C13.9229 9 13 9.91526 13 11.0454V36.9546C13 38.0847 13.9229 39 15.0624 39Z" fill="#00AC47"></path><path d="M27 9L35 17H27V9Z" fill="#00832D"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M31 31V21H17V31H31ZM18.5555 22.5384H23.2222V25.2307H18.5555V22.5384ZM18.5555 29.4616V26.7693H23.2222V29.4616H18.5555ZM29.4445 29.4616H24.7778V26.7693H29.4445V29.4616ZM29.4445 25.2307H24.7778V22.5384H29.4445V25.2307Z" fill="white"></path></svg>
</template>

<style scoped>

</style>